function parseDate(value) {
  if (!value) {
    return null;
  }
  if (typeof value === 'string' && /^\d{2}-\d{2}$/.test(value)) {
    const [month, day] = value.split('-').map(Number);
    const date = new Date(2000, month - 1, day);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function isMonthDay(value) {
  return typeof value === 'string' && /^\d{2}-\d{2}$/.test(value);
}

/** Date only, e.g. "Jun 23, 2026". Month-day values like "01-01" render as "Jan 1". */
export function formatDate(value) {
  const date = parseDate(value);
  if (!date) {
    return value ? String(value) : '—';
  }
  if (isMonthDay(value)) {
    return date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
  return date.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/** Date and time, e.g. "Jun 23, 2026, 4:28 PM" */
export function formatDateTime(value) {
  const date = parseDate(value);
  if (!date) {
    return value ? String(value) : '—';
  }
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
